import { useCallback, useEffect, useState } from "react";
import Table, { ITableRow } from "../../components/table/table";
import { useParams } from "react-router";
import { applicantsHttpService } from "@myinnsworth/httpServices";
import { format } from "date-fns";
import { Link } from "react-router-dom";
import ICase from "@myinnsworth/models/case/ICase";
import { NumericFormat } from 'react-number-format';
import { useAppStore } from "@myinnsworth/hooks/appStoreHook";
import Icon from "components/icon/icon";

export default function ClaimantDetailsViewFunds() {

    const headers = [
        { name: 'Name' },
        { name: 'Last updated' },
        { name: 'Legal entity' },
        { name: 'Total loss' },
        { name: 'Action' }
    ];

    const appStore = useAppStore();
    const [rows, setRows] = useState<Array<ITableRow>>([]);
    const params = useParams();
    const [pageNo, setPageNo] = useState<number>(1);
    const [totalResults, setTotalResults] = useState<number>(0);
    const [currentCase, setCurrentCase] = useState<ICase | undefined>(appStore.findCase(params.slug!));

    const refreshApplicants = useCallback(async () => {
        try {
            const applicantResults = await applicantsHttpService.SearchInstitutionFunds({
                caseSlug: params.slug!,
                institutionId: parseInt(params.institutionId!),
                pageNo: pageNo
            });
            setTotalResults(applicantResults.total);

            setRows(applicantResults.results.map(applicant => {
                return {
                    cells: [
                        applicant.name,
                        format(applicant.lastUpdated, 'dd/MM/yyyy'),
                        applicant.legalEntity,
                        <NumericFormat value={applicant.lossResults.map(x => x.lossAmount).reduce((p, x) => p + x).toFixed(2)} thousandSeparator displayType="text" prefix={currentCase?.currency.symbol} />,
                        <>
                            <Link to={`/cases/${params.slug}/claimant-details/${params.institutionId}/view/funds/${applicant.id}/view/index`} onClick={() => appStore.setCurrentApplicant(applicant)}>
                                <Icon name="view" pointer />
                            </Link>
                            <Link style={{ paddingLeft: '10px' }} to={`/cases/${params.slug}/claimant-details/${params.institutionId}/view/funds/${applicant.id}/view/files`} >
                                <Icon name="folder" pointer />
                            </Link>
                        </>
                    ]
                };
            }));
        } catch { }
    }, [params.slug, params.institutionId, pageNo, currentCase]);

    useEffect(() => {
        refreshApplicants();
    }, [refreshApplicants]);

    return (

        <Table headers={headers}
            rows={rows}
            allowPaging={true}
            actionIndex={4}
            nameIndex={0}
            currentPage={pageNo}
            totalResults={totalResults}
            resultsPerPage={5}
            onChangePage={p => setPageNo(p)} />
    )
}